module.exports = __webpack_public_path__ + "static/media/graphQL.15f93a2f.png";